import { PostboxDocument } from 'cpnl-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { PostboxDocumentsDataSelector } from './PostboxDocumentsSelector';
import { fetchPostboxDocuments } from './PostboxDocumentsSlice';

export function usePostboxDocuments(): AbstractDataState<PostboxDocument[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchPostboxDocuments, PostboxDocumentsDataSelector);
}
